module.exports = __webpack_public_path__ + "static/screenshot3-fc89850b15279a5701b5d7c3687a2757.png";